import * as React from 'react';
import { ReactNode } from 'react';
import { RootState } from 'src/reducers/RootReducer';
import { connect } from 'react-redux';

interface StateProps {
  location: string | null;
}

interface Props extends StateProps {
}

interface State {
  lastLocation: string;
}

class ScrollComponent extends React.Component<Props, State> {

  public shouldComponentUpdate(nextProps: Props): boolean {
    if (this.props.location === nextProps.location) {
      return true;
    }

    window.scrollTo(0, 0);
    return true;
  }

  public render(): ReactNode {
    return (
      React.Children.only(this.props.children)
    );
  }
}

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  location: state.router.location ? state.router.location.pathname : '',
});

export default connect(mapStateToProps)(ScrollComponent);



// WEBPACK FOOTER //
// ./src/services/middleware/Scroll.component.tsx